// removed by extract-text-webpack-plugin
module.exports = {"error":"_2uSSz","headerCode":"_1nDxs","headerMessage":"_2A_du"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/ErrorPage/index.sass
// module id = 1475
// module chunks = 1